import { createNewPathForLocationSlug } from "@modules/util/url"

export function updateLocationLinks(seoUrl: string) {
    const locationLinks = document.querySelectorAll<HTMLAnchorElement>("[data-location-slug]")
    for (const locationLink of locationLinks) {
        const citySlug = locationLink.getAttribute("data-location-slug") || ""
        locationLink.href = createNewPathForLocationSlug(seoUrl, citySlug)
    }
}

updateLocationLinks(window.location.href)
